export default "__VITE_ASSET__5ac31216__"